import { DeprecatedSingleSelectOption } from '@opallabs/lapidary'

export const variantOptions: Array<DeprecatedSingleSelectOption> = [
  { value: 'translate', label: 'Translate' },
  { value: 'different_tone', label: 'Different Tone' },
  { value: 'different_approach', label: 'Different Approach' },
  { value: 'find_and_replace', label: 'Find & Replace' },
]

export const translationOptions: Array<DeprecatedSingleSelectOption> = [
  { value: 'english', label: '🇺🇸 English' },
  { value: 'british_english', label: '🇬🇧 English (British)' },
  { value: 'spanish', label: '🇪🇸 Spanish (Spain)' },
  { value: 'latin_american_spanish', label: '🇲🇽 Spanish (Latin America)' },
  { value: 'brazilian_portuguese', label: '🇧🇷 Portuguese (Brazil)' },
  { value: 'european_portuguese', label: '🇵🇹 Portuguese (Portugal)' },
  { value: 'mandarin_chinese', label: '🇨🇳 Mandarin Chinese' },
  { value: 'cantonese', label: '🇭🇰 Cantonese (Hong Kong)' },
  { value: 'french_european', label: '🇫🇷 French (France)' },
  { value: 'french_canadian', label: '🇨🇦 French (Canada)' },
  { value: 'german', label: '🇩🇪 German' },
  { value: 'italian', label: '🇮🇹 Italian' },
  { value: 'dutch', label: '🇳🇱 Dutch' },
  { value: 'russian', label: '🇷🇺 Russian' },
  { value: 'polish', label: '🇵🇱 Polish' },
  { value: 'turkish', label: '🇹🇷 Turkish' },
  { value: 'japanese', label: '🇯🇵 Japanese' },
  { value: 'korean', label: '🇰🇷 Korean' },
  { value: 'vietnamese', label: '🇻🇳 Vietnamese' },
  { value: 'arabic', label: '🇸🇦 Arabic (Saudi Arabia)' },
  { value: 'egyptian_arabic', label: '🇪🇬 Arabic (Egypt)' },
  { value: 'hindi', label: '🇮🇳 Hindi' },
  { value: 'bengali', label: '🇧🇩 Bengali (Bangladesh)' },
  { value: 'punjabi', label: '🇵🇰 Punjabi (Pakistan)' },
  { value: 'indonesian', label: '🇮🇩 Indonesian' },
  { value: 'thai', label: '🇹🇭 Thai' },
  { value: 'tagalog_filipino', label: '🇵🇭 Tagalog (Filipino)' },
  { value: 'malay', label: '🇲🇾 Malay' },
  { value: 'swedish', label: '🇸🇪 Swedish' },
  { value: 'norwegian', label: '🇳🇴 Norwegian' },
  { value: 'danish', label: '🇩🇰 Danish' },
  { value: 'finnish', label: '🇫🇮 Finnish' },
  { value: 'greek', label: '🇬🇷 Greek' },
  { value: 'czech', label: '🇨🇿 Czech' },
  { value: 'hungarian', label: '🇭🇺 Hungarian' },
  { value: 'ukrainian', label: '🇺🇦 Ukrainian' },
  { value: 'hebrew', label: '🇮🇱 Hebrew' },
  { value: 'farsi_persian', label: '🇮🇷 Persian (Farsi)' },
  { value: 'romanian', label: '🇷🇴 Romanian' },
  { value: 'bulgarian', label: '🇧🇬 Bulgarian' },
  { value: 'croatian', label: '🇭🇷 Croatian' },
  { value: 'serbian', label: '🇷🇸 Serbian' },
  { value: 'albanian', label: '🇦🇱 Albanian' },
  { value: 'estonian', label: '🇪🇪 Estonian' },
  { value: 'lithuanian', label: '🇱🇹 Lithuanian' },
  { value: 'latvian', label: '🇱🇻 Latvian' },
  { value: 'slovak', label: '🇸🇰 Slovak' },
  { value: 'slovenian', label: '🇸🇮 Slovenian' },
  { value: 'irish_gaelic', label: '🇮🇪 Irish Gaelic' },
  { value: 'welsh', label: '🏴󠁧󠁢󠁷󠁬󠁳󠁿 Welsh' },
  { value: 'icelandic', label: '🇮🇸 Icelandic' },
]
